<template>
  <svg
    v-show="!readonly"
    @click.stop="editCard"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    class="editIcon"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_5804_11650)">
      <path
        d="M7.33301 2.66663H2.66634C2.31272 2.66663 1.97358 2.8071 1.72353 3.05715C1.47348 3.3072 1.33301 3.64634 1.33301 3.99996V13.3333C1.33301 13.6869 1.47348 14.0261 1.72353 14.2761C1.97358 14.5262 2.31272 14.6666 2.66634 14.6666H11.9997C12.3533 14.6666 12.6924 14.5262 12.9425 14.2761C13.1925 14.0261 13.333 13.6869 13.333 13.3333V8.66663"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.333 1.66665C12.5982 1.40144 12.9579 1.25244 13.333 1.25244C13.7081 1.25244 14.0678 1.40144 14.333 1.66665C14.5982 1.93187 14.7472 2.29158 14.7472 2.66665C14.7472 3.04173 14.5982 3.40144 14.333 3.66665L7.99967 9.99999L5.33301 10.6667L5.99967 7.99999L12.333 1.66665Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5804_11650">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'EventSvgTableEditIcon',
    props: {
      itemId: {
        type: Number,
        default: null,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: '16',
      },
    },
    methods: {
      editCard() {
        this.$emit('edit', this.itemId);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .editIcon {
    stroke: $base;
    transition: 0.3s;

    &:hover {
      stroke: #0000ee;
    }
  }
</style>
